<main id="main">
    <section class="academy academy-thank-you-section thankyou">
        <div class="container aos-init aos-animate">
            <div class="row">
                <div class="col-md-12 quiz-main-body">
                    <div class="content">
                        <div class="container-fluid">

                            <div class="col-md-12 mp-0">
                                <div class="jumbotron text-center">
                                    <div class="Thank-you-gif">
                                        <img src="assets/img/players/output-onlinegiftools.gif" alt="">
                                    </div>
                                    <h1 class="display-6 mb-0 mt-6">Welcome Onboard!</h1>
                                    <p class="lead"><strong>Your mobile number verified successfully.
                                        </strong>
                                    </p>
                                    <!-- <span class="ticket">Your TPL ticket has been claimed - enjoy the
                                        experience!</span>
                                    <br />
                                    <br /> -->
                                    <!-- <div class="ticketContainer">
                                        <div class="ticket">
                                          <div class="ticketTitle">Congratulations! <i class='bx bx-party'></i></div>
                                          <hr>
                                          <div class="ticketDetail">
                                            <div> Your TPL ticket has been claimed - enjoy the experience!</div>
                                            
                                          </div>
                                          <div class="ticketRip">
                                            <div class="circleLeft"></div>
                                            <div class="ripLine"></div>
                                            <div class="circleRight"></div>
                                          </div>
                                          <div class="ticketSubDetail">
                                            <div class="date"> 12<sup>th</sup> To 17<sup>th</sup> December 2023</div>
                                            <div class="code">
                                                Time: 4:00 Pm Onwards
                                                
                                            </div> 
                                            
                                          </div>
                                        </div>
                                        <div class="ticketShadow"></div>
                                      </div> -->
                                    <!-- <p class="lead"><strong>Your TPL ticket has been claimed - enjoy the
                                            experience!</strong></p> -->
                                    <hr>
                                    <p>
                                        Please <a (click)="openSignin()" style="color: #34c759; cursor: pointer;">Click here</a> and
                                        complete your Profile.
                                    </p>

                                </div>
                            </div>
                        </div> <!-- ENd of container fluid -->

                    </div>
                </div>
            </div>
        </div>
    </section>
</main>